/**
 * Mega Menu Click Handler (Desktop Only)
 * Replaces hover behavior with click to open/close mega menus
 */

class MegaMenuClick {
  constructor() {
    this.menuItems = [];
    this.isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
    this.init();
  }

  init() {
    // Only run on desktop
    if (!this.isDesktop()) return;

    // Find all navigation items that have a mega menu or dropdown
    this.menuItems = Array.from(
      document.querySelectorAll('.navigation-main > .navigation-item')
    ).filter(item => {
      return item.querySelector('.navigation-sub-menu, .mega-menu');
    });

    this.attachEventListeners();
    this.handleResize();
  }

  attachEventListeners() {
    // Add click listeners to menu items with submenus
    this.menuItems.forEach(item => {
      const link = item.querySelector(':scope > a');
      if (!link) return;

      // Prevent default navigation and toggle mega menu
      link.addEventListener('click', (e) => {
        if (!this.isDesktop()) return; // Safety check

        e.preventDefault();
        e.stopPropagation();
        this.toggleMenu(item);
      });
    });

    // Close mega menu when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.isDesktop()) return;

      const clickedInsideMenu = e.target.closest('.navigation-main');
      if (!clickedInsideMenu) {
        this.closeAllMenus();
      }
    });

    // Close mega menu on ESC key
    document.addEventListener('keydown', (e) => {
      if (!this.isDesktop()) return;

      if (e.key === 'Escape') {
        this.closeAllMenus();
      }
    });
  }

  toggleMenu(item) {
    const isOpen = item.classList.contains('mega-menu-open');
    const link = item.querySelector(':scope > a');

    if (isOpen) {
      // Si déjà ouvert, le fermer
      item.classList.remove('mega-menu-open');
      item.setAttribute('aria-expanded', 'false');
      if (link) link.blur(); // Retirer le focus pour éviter :focus-within
    } else {
      // Si fermé, fermer les autres et l'ouvrir
      this.closeAllMenus();
      item.classList.add('mega-menu-open');
      item.setAttribute('aria-expanded', 'true');
    }
  }

  closeAllMenus() {
    this.menuItems.forEach(item => {
      item.classList.remove('mega-menu-open');
      item.setAttribute('aria-expanded', 'false');
    });
  }

  handleResize() {
    // Close all menus when switching from desktop to mobile
    let wasDesktop = this.isDesktop();

    window.addEventListener('resize', () => {
      const isNowDesktop = this.isDesktop();

      if (wasDesktop && !isNowDesktop) {
        // Switched from desktop to mobile
        this.closeAllMenus();
      }

      wasDesktop = isNowDesktop;
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MegaMenuClick();
  });
} else {
  new MegaMenuClick();
}
